import packageInfo from '../../../package.json';
import { PLUGIN_NAME } from './constants';
import pageBuilderComponents from './components/page-builder-component';

const { version } = packageInfo;
async function load(app) {
  app.log.debug('loaded kp access-code plugin');

  app.events.on('load:custom:page-builder:component', addComponent => {
    Object.keys(pageBuilderComponents).forEach(key =>
      addComponent({ key, component: pageBuilderComponents[key] })
    );
  });

  return {
    name: PLUGIN_NAME,
    version
  };
}

load.pluginName = PLUGIN_NAME;

export default load;
